import { yup } from '@dis/form'
import { MAX_TENANT_NAME } from '@dis/constants'

export const yupTenantNameValidation = yup.string().required().trim().min(3).max(MAX_TENANT_NAME)
